import { ButtonHTMLAttributes } from 'react';
import { ContentButton, IconWrapper } from './styles';

function RightArrow(
  props: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'css'>,
): JSX.Element {
  return (
    <ContentButton {...props}>
      <IconWrapper arrowPosition="right">
        <svg
          width="13"
          height="23"
          viewBox="0 0 13 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            y1="-1"
            x2="15.3887"
            y2="-1"
            transform="matrix(-0.731055 0.682318 -0.731055 -0.682318 11.25 10.5)"
            stroke="#525255"
            strokeWidth="2"
          />
          <line
            y1="-1"
            x2="15.3887"
            y2="-1"
            transform="matrix(-0.731055 -0.682318 -0.731055 0.682318 11.25 12.75)"
            stroke="#525255"
            strokeWidth="2"
          />
        </svg>
      </IconWrapper>
    </ContentButton>
  );
}

export default RightArrow;
